import debug from 'debug';
import GoogleAnalytics from 'Minetilbud/Shared/Components/GoogleAnalyticsEvents/DataLayer';
import MatomoTagManager from 'Minetilbud/Shared/Components/matomo/tag-manager';

const log = debug('BoostBanner:Utils:DataLayer');
const googleAnalytics = new GoogleAnalytics();
const matomoTagManager = new MatomoTagManager();

class DataLayer {
	/**
	 * @param {string} name
	 */
	static view(name) {
		matomoTagManager.set({
			event: 'boost_banner_view',
			boost_banner_name: name
		})
	}

	/**
	 * @param {string} name
	 */
	static click(name) {
		matomoTagManager.set({
			event: 'boost_banner_click',
			product: name
		})
	}

}

export default DataLayer;
